import type { UiIconName } from "@dpa-id-components/dpa-shared-components/src/components/UiIcon/UiIcon.vue";
import type { UiTShirtSizeIconName } from "@dpa-id-components/dpa-shared-components/src/components/UiTShirtSizeIcon/UiTShirtSizeIcon.vue";

import type {
  ContentBaseItem,
  ReducedAudioItem,
  ReducedContentItem,
  ReducedRelatedStoryItem,
  ReducedTextItem,
  ReducedThumbnailItem,
  ReducedVideoItem,
} from "@/types/content.d.ts";
import { MediaType } from "@/types/enums.ts";
import type { UserNeed } from "@/types/ui.ts";

export enum DpaServices {
  DPA_AFX_PRO_FEED = "afxsrv:ADE",
  DPA_AFX_COMPACT = "afxsrv:ADL",
  DPA_AFX_INTERNATIONAL_PRO_FEED = "afxsrv:DRR",
  SACHSEN_ANHALT = "dpasrv:aht",
  RUFA_AUDIODIENST = "dpasrv:ainterview",
  "RUFA_GESPRAECHE_&_INTERVIEWS" = "dpasrv:akorri-talk",
  DPA_GESPROCHENE_NACHRICHTEN = "dpasrv:anachrichten_lang",
  ASIAN_NEWS_NETWORK_SERVICE = "dpasrv:ann-news",
  RUFA_NACHRICHTENSTUECKE = "dpasrv:anstueck",
  RUFA_O_TON = "dpasrv:ao-ton",
  AP_EUROPEAN_NEWS_SERVICE = "dpasrv:apwire",
  AP_WELTNACHRICHTEN = "dpasrv:apx",
  DPA_INTERNATIONAL_ARABIC_MULTIMEDIA = "dpasrv:arabic-mm",
  REPORT = "dpasrv:barch",
  BAYERN = "dpasrv:bay",
  DPA_BILDFUNK = "dpasrv:bbasis",
  DPA_I = "dpasrv:bdpai",
  BASISDIENST = "dpasrv:bdt",
  BASISDIENST_INLAND = "dpasrv:bid",
  BILDFUNK_KINDER = "dpasrv:bkind",
  ORIGINAL_BILDER_SERVICE = "dpasrv:bobs",
  BERLIN_BRANDENBURG = "dpasrv:brb",
  THEMENDIENST_BILD = "dpasrv:btmn",
  BADEN_WUERTTEMBERG = "dpasrv:bwg",
  ZB_REGIO = "dpasrv:bzbreg",
  DOSSIER_WISSEN = "dpasrv:dossier-wis",
  DPA_INTERNACIONAL = "dpasrv:dpa-espanol",
  DPA_INTERNACIONAL_LATAM_COOP = "dpasrv:dpa-espanol-latam-coop",
  DPA_INTERNATIONAL = "dpasrv:eca",
  DPA_INTERNATIONAL_MULTIMEDIA = "dpasrv:eca-mm",
  DPA_INTERNATIONAL_BASIC = "dpasrv:eca-solo",
  EUROPADIENST_AUF_AFP_ECS_UPLINK = "dpasrv:edi",
  EUROPADIENST_FUER_AFP = "dpasrv:edt",
  EUROPADIENST = "dpasrv:erd",
  DPASRV_ERD_CH = "dpasrv:erd-ch",
  DPASRV_ERD_CH_MM = "dpasrv:erd-ch-mm",
  FAKTENCHECK = "dpasrv:factchecking",
  DPA_FEATURE_ARABIC = "dpasrv:feature-ar",
  DPA_CONSUMER_NEWS_ARABIC = "dpasrv:feature-consumer-ar",
  "DPA_TRENDS_&_FEATURES" = "dpasrv:feature-special-en",
  GLO_BIZZ = "dpasrv:graphics-biz",
  GRAFIK = "dpasrv:graphics-dpa",
  GLOBUS_GRAFIK = "dpasrv:graphics-glo",
  GRAFIK_SCHWEIZ = "dpasrv:graphics-sch",
  GLOBUS_STEPS = "dpasrv:graphics-stp",
  HESSEN = "dpasrv:hes",
  KURZNACHRICHTENDIENST = "dpasrv:hfk",
  HAMBURG_SCHLESWIG_HOLSTEIN = "dpasrv:hsh",
  PA_BILDFEED_DE = "dpasrv:images-de",
  PA_BILDFEED_DE_3P = "dpasrv:images-de-3p",
  PA_BILDFEED_DE_INT = "dpasrv:images-de-int",
  PA_BILDFEED_DE_NAT = "dpasrv:images-de-nat",
  PA_BILDFEED_DE_ZB = "dpasrv:images-de-zb",
  VORSCHAU_AUDIODIENST = "dpasrv:kom",
  MAGAZIN = "dpasrv:mag",
  MECKLENBURG_VORPOMMERN = "dpasrv:mbv",
  NACHRICHTEN_FUER_KINDER = "dpasrv:ndk",
  NIEDERSACHSEN_BREMEN = "dpasrv:nsb",
  NORDRHEIN_WESTFALEN = "dpasrv:nwf",
  AP_EUROPEAN_PHOTOSTREAM = "dpasrv:photostream-ap-en",
  DPA_INTERNATIONAL_PHOTO_COMBI = "dpasrv:photostream-combi",
  BILDFUNK = "dpasrv:photostream-de",
  DPA_BILDERDIENST_DE_3P = "dpasrv:photostream-de-3p",
  DPA_BILDERDIENST_DE_IN = "dpasrv:photostream-de-int",
  DPA_BILDERDIENST_DE_NAT = "dpasrv:photostream-de-nat",
  DPA_BILDERDIENST_DE_SEL = "dpasrv:photostream-de-sel",
  DPA_BILDERDIENST_DE_TO = "dpasrv:photostream-de-top",
  DPA_INTERNATIONAL_PHOTO_DOMESTIC = "dpasrv:photostream-domestic",
  DPA_INTERNATIONAL_PHOTO_DOMESTIC_ALL = "dpasrv:photostream-domestic-all",
  DPA_INTERNATIONAL_PHOTO = "dpasrv:photostream-en",
  DPA_INTERNATIONAL_PHOTO_INTERNATIONAL_ALL = "dpasrv:photostream-int-all",
  ZENTRALBILD = "dpasrv:photostream-zb",
  RHEINLAND_PFALZ_SAARLAND = "dpasrv:rhs",
  SACHSEN = "dpasrv:san",
  DPA_KINDERSPARTE = "dpasrv:section-de-child",
  DPA_THEMENDIENST = "dpasrv:section-de-tmn",
  SPORT_ERGEBNISDIENST = "dpasrv:spe",
  GLOBAL_ARABIC_NEWS_SERVICE = "dpasrv:text-arabic",
  THUERINGEN = "dpasrv:thg",
  THEMENDIENST = "dpasrv:tmn",
  VIDEO_ROHMATERIAL = "dpasrv:video-digital-raw",
  VIDEO_BEITRAEGE = "dpasrv:video-digital-rtp",
  REGIOLINE_SACHSEN_ANHALT = "dpasrv:wap-aht",
  REGIOLINE_BAYERN = "dpasrv:wap-bay",
  REGIOLINE_BERLIN_BRANDENBURG = "dpasrv:wap-brb",
  REGIOLINE_BADEN_WUERTTEMBERG = "dpasrv:wap-bwg",
  REGIOLINE_HESSEN = "dpasrv:wap-hes",
  REGIOLINE_HAMBURG___SCHLESWIG_HOLSTEIN = "dpasrv:wap-hsh",
  REGIOLINE_MECKLENBURG_VORPOMMERN = "dpasrv:wap-mbv",
  REGIOLINE_NIEDERSACHSEN_BREMEN = "dpasrv:wap-nsb",
  REGIOLINE_NORDRHEIN_WESTFALEN = "dpasrv:wap-nwf",
  REGIOLINE_RHEINLAND_PFALZ_SAARLAND = "dpasrv:wap-rhs",
  REGIOLINE_SACHSEN = "dpasrv:wap-san",
  REGIOLINE_THUERINGEN = "dpasrv:wap-thg",
  XINHUA_WIRTSCHAFTSINFO = "dpasrv:xinhua-industry-40",
  OTS_ENGLISCH = "nasrv:neo",
  OTS_SCHWEIZ = "nasrv:otsch",
  OTS_ESPANOL = "nasrv:otses",
  OTS_BLAULICHT = "ots-pol",
  OTS_PR = "ots-pr",
  RUFA_AUDIO_HSH = "dpasrv:audio-hsh",
  RUFA_AUDIO_HES = "dpasrv:audio-hes",
  RUFA_AUDIO_AHT = "dpasrv:audio-aht",
}

export enum DpaProducts {
  BASISDIENST = "dpaprd:basisdienst",
  BILDFUNK = "dpaprd:bildfunk",
  SACHSEN_ANHALT = "dpaprd:aht",
  BAYERN = "dpaprd:bay",
  SACHSEN = "dpaprd:san",
  THUERINGEN = "dpaprd:thg",
  BERLIN_BRANDENBURG = "dpaprd:brb",
  BADEN_WUERTTEMBERG = "dpaprd:bwg",
  HESSEN = "dpaprd:hes",
  HAMBURG_SCHLESWIG_HOLSTEIN = "dpaprd:hsh",
  MECKLENBURG_VORPOMMERN = "dpaprd:mbv",
  NIEDERSACHSEN_BREMEN = "dpaprd:nsb",
  NORDRHEIN_WESTFALEN = "dpaprd:nwf",
  RHEINLAND_PFALZ_SAARLAND = "dpaprd:rhs",
}

export const iconMap = new Map<
  UserNeed,
  Extract<
    UiIconName,
    | "user-need-update-me"
    | "user-need-give-me-perspective"
    | "user-need-educate-me"
    | "user-need-help-me"
    | "user-need-inspire-me"
    | "user-need-touch-me"
    | "user-need-divert-me"
  >
>([
  ["dpauserneed:updateme", "user-need-update-me"],
  ["dpauserneed:givemeperspective", "user-need-give-me-perspective"],
  ["dpauserneed:educateme", "user-need-educate-me"],
  ["dpauserneed:helpme", "user-need-help-me"],
  ["dpauserneed:inspireme", "user-need-inspire-me"],
  ["dpauserneed:touchme", "user-need-touch-me"],
  ["dpauserneed:divertme", "user-need-divert-me"],
]);

export const tShirtSizeIconMap = new Map<string, UiTShirtSizeIconName>([
  ["dpatshirtsize:m", "m"],
  ["dpatshirtsize:l", "l"],
  ["dpatshirtsize:xl", "xl"],
]);

export function isReducedThumbnailItem(
  item: ReducedContentItem | ContentBaseItem,
): item is ReducedThumbnailItem {
  return Object.prototype.hasOwnProperty.call(item, "thumbnail");
}

// The bookmarked Story item is identical to the Text item.
// The related content Story item is different
export function isReducedTextItem(
  item: ReducedContentItem | ContentBaseItem,
): item is ReducedTextItem {
  return (
    (item.mediaType === MediaType.TEXT || item.mediaType === MediaType.STORY) &&
    Object.prototype.hasOwnProperty.call(item, "wordCount") &&
    Object.prototype.hasOwnProperty.call(item, "genres")
  );
}

export function isReducedRelatedStoryItem(
  item: ReducedContentItem | ContentBaseItem,
): item is ReducedRelatedStoryItem {
  return (
    item.mediaType === MediaType.STORY &&
    Object.prototype.hasOwnProperty.call(item, "kicker") &&
    Object.prototype.hasOwnProperty.call(item, "bodyCharCount")
  );
}

export function isReducedAudioItem(
  item: ReducedContentItem | ContentBaseItem,
): item is ReducedAudioItem {
  return (
    item.mediaType === MediaType.AUDIO &&
    Object.prototype.hasOwnProperty.call(item, "durationInSeconds")
  );
}

export function isReducedVideoItem(
  item: ReducedContentItem | ContentBaseItem,
): item is ReducedVideoItem {
  return (
    item.mediaType === MediaType.VIDEO &&
    Object.prototype.hasOwnProperty.call(item, "durationInSeconds")
  );
}
